import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { LocalStorageUtils } from "../helpers/LocalStorage";
import { BASE_URL } from "../constants/stringConstants";

export const chatApi = createApi({
  reducerPath: "chats",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set("Accept", "application/json");
      // headers.set("Content-Type", "multipart/form-data");
      const token = LocalStorageUtils.getItem("auth_token");
      if (token && endpoint !== "/auth/login" && endpoint !== "/auth/signup") {
        headers.set("Authorization", `Bearer ${JSON.parse(token)}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getChatList: builder.mutation<any, any>({
      query: ({ filterDetails, param }) => ({
        url: `candidates/${param}/chat-sessions?filter=${filterDetails}`,
        method: "GET",
      }),
    }),

    getChats: builder.mutation<any, any>({
      query: ({ filterDetails, param }) => ({
        url: `chat-sessions/${param}/chats?filter=${filterDetails}`,
        method: "GET",
      }),
    }),

    getChatDetails: builder.mutation<any, any>({
      query: ({ filterDetails, param }) => ({
        url: `chat-sessions/${param}?filter=${filterDetails}`,
        method: "GET",
      }),
    }),

    sendChatMessage: builder.mutation<any, any>({
      query: (message) => ({
        url: `chats`,
        method: "POST",
        body: message,
      }),
    }),

    acceptInterviewInvite: builder.mutation<any, any>({
      query: ({ param, ...rest }) => ({
        url: `interview/${param}`,
        method: "PATCH",
        body: rest,
      }),
    }),
  }),
});

export const {
  useGetChatListMutation,
  useGetChatsMutation,
  useGetChatDetailsMutation,
  useSendChatMessageMutation,
  useAcceptInterviewInviteMutation,
} = chatApi;

// 'https://123.123.123.123/goods/121'
